import React, { useEffect, useState } from "react";
import moment from "moment";
import { GrAttachment } from "react-icons/gr";
import { useDocumentContext } from "../../Documents";
import { shallowEqual, useSelector } from "react-redux";
// import AddTaskDialog from "../../../Triage-Module/AddTaskDialog";
import ActionMenuList from "../../../../components/ActionMenuList";
import { CheckBox } from "../../../../components/reactHookFormFields/checkbox";
import Share from "../../../../components/ShareEmaileFax/Share";
import { trimString } from "../../../../helper";

export const DocumentItem = ({
  document,
  selectedFiles,
  setSelectedFiles,
  uploadedList,
  selectedChat
}) => {
  const documentContext = useDocumentContext();
  const [shareDialog, setShareDialog] = useState(false);
  const [addToTaskDilaogState, setAddToTaskDilaogState] = useState(false);

  // const { selectedNote } = useSelector(
  //   ({ providerNote }) => ({
  //     selectedNote: providerNote.selectedNote,
  //   }),
  //   shallowEqual
  // );
  const handleSelectedDoc = (data, e) => {
    if (e.target.checked) {
      setSelectedFiles([...selectedFiles, data]);
    } else {
      setSelectedFiles(
        selectedFiles?.length > 0 &&
          selectedFiles?.filter((v) => {
            return data?.id != v?.id;
          })
      );
    }
  };

  const returnMenuButtons = (document) => {
    const buttons = [
      {
        label: "Edit",
        onClick: () => {
          documentContext?.editHandler(document);
        },
      },
      {
        label: "Delete",
        labelStyle: "text-red-500",
        onClick: () => documentContext?.deleteDoc(document),
      },
      !document?.file_title.includes("xlsx") && {
        label: "Print",
        onClick: () => documentContext?.openDocument(document),
      },
      !document?.file_title.includes("xlsx") && {
        label: "Share",
        onClick: () => setShareDialog(true),
      },
    ];

    // const linkedDocuments = selectedNote?.clinical_data?.documents?.split(",");
    // if (!linkedDocuments?.includes(document.id)) {
    //   buttons.push({
    //     label: "Add to Note",
    //     onClick: () => documentContext?.linkResultWithNote(document),
    //   });
    // }

    // if (linkedDocuments?.includes(document.id)) {
    //   buttons.push({
    //     label: "Remove from Note",
    //     onClick: () => documentContext?.linkResultWithNote(document, true),
    //   });
    // }

    buttons.push({
      label: "Assign Task",
      onClick: () => {
        setAddToTaskDilaogState(true);
      },
    });

    return buttons;
  };

  return (
    <>
      <tr className="border-left-d-blue-c-550 gray-c-150">
        {shareDialog && (
          <Share
            from={"document"}
            sharePreviewUrl={"messages/read_attachment?uuid"}
            printData={"printData"}
            setShowShareeFax={setShareDialog}
            userUniqueId={{ uuid: document?.uuid, title: document?.title }}
          />
        )}

        {/* {addToTaskDilaogState && (
          <AddTaskDialog
            selectedTask={""}
            singleShedule={""}
            addToTaskDilaogState={addToTaskDilaogState}
            setAddToTaskDilaogState={setAddToTaskDilaogState}
            document={document}
          />
        )} */}
        {/*<td className="relative w-12 px-4 py-4 align-top">
        <input type="checkbox" className=" h-4 w-5 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 sm:left-6" />
      </td>*/}
        <td className="px-2 pt-3 pb-1 align-top">
          <p
            title={
              uploadedList?.length > 0 &&
              uploadedList?.map((v, index) => {
                if (v?.id == document?.id) {
                  return "Document Already Added";
                } else {
                  return null;
                }
              })
            }
            className="flex break-words items-start text-sm black-c-600 mt-1 font-normal mb-1"
          >
            <CheckBox
              name={`doc_${document.id}`}
              disabled={
                uploadedList?.length > 0 &&
                uploadedList?.find((v, index) => v?.id == document?.id)
              }
              control={documentContext?.control}
              onChange={(e) => {
                handleSelectedDoc(document, e);
                documentContext?.onChangeSelection;
              }}
            />

            <div
              className="flex text-bgGreen hover:text-black-300 cursor-pointer"
              onClick={() => documentContext?.openDocument(document)}
            >
              <GrAttachment size="20" className="mr-1" /> {document?.title}
            </div>
          </p>
        </td>
        <td className="whitespace-nowrap px-2 py-4 text-sm text-black-c-400 align-top">
          {document?.category_title || ""}
        </td>
        <td className="whitespace-nowrap px-2 py-4 text-sm align-top">
          <span>{trimString(document?.description, 40)}</span>
        </td>
        <td className="break-words px-2 py-4 text-sm align-top w-40">
          {document?.added_by_user}
        </td>
        <td className="break-words px-2 py-4 text-sm align-top w-20">
          {document?.date || ""}
        </td>
        <td className="break-words px-2 py-4 text-sm align-top w-20">
          {(document?.file_size / 1000).toFixed(1)} KB
        </td>
        {/* <td className="whitespace-nowrap py-2 px-4 text-right align-top w-[50px]">
          <ActionMenuList
            title="Actions"
            menuList={returnMenuButtons(document)}
          />
        </td> */}
      </tr>
    </>
  );
};
